<template>
  <div>
    <div>
      <el-row :gutter="10" style="margin: 0px 0 0 4px">
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span> 时间类型： </span>
          <el-radio-group
            v-model="dataTpye"
            @change="getShowMonthData"
            size="mini"
          >
            <el-radio label="currMonth">当月</el-radio>
            <el-radio label="all">本年累计</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span> 数据指标： </span>
          <el-select
            v-model="dataIndex"
            size="mini"
            placeholder="请选择"
            @change="getShowData"
          >
            <el-option
              v-for="item in dataIndexOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span style="margin-left: 24px"> 时间： </span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-model="times"
            type="monthrange"
            size="mini"
            value-format="yyyy-MM"
            @change="monthChange"
            :picker-options="pickerOptions"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row style="margin: 10px 15px">
        <el-col :span="24">
          <Area v-if="showArea" :area-data="areaData" />
        </el-col>
      </el-row>
    </div>

    <el-link style="margin: 20px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div>
      <el-row>
        <el-col :span="24">
          <el-table
            border
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            v-loading="loading"
            size="mini"
            :row-class-name="tableRowClassName"
            :data="tableData"
          >
            <el-table-column type="index" label="序号" width="50" fixed>
            </el-table-column>
            <el-table-column prop="date_range_show" label="时间" fixed>
            </el-table-column>
            <el-table-column
              :label="
                dataIndexOptions.find((ele) => ele.value === dataIndex).label
              "
            >
              <el-table-column prop="benyue" sortable label="本月">
                <template slot-scope="scope">
                  <span>{{ scope.row.benyue.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="dyhb" sortable label="当月环比（±）">
                <template slot-scope="scope">
                  <span>{{ scope.row.dyhb.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="dytb" sortable label="当月同比（±）">
                <template slot-scope="scope">
                  <span>{{ scope.row.dytb.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="bylj1" sortable label="1-本月累计">
                <template slot-scope="scope">
                  <span>{{ scope.row.bylj1.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ljtb" sortable label="累计同比（±）">
                <template slot-scope="scope">
                  <span>{{ scope.row.ljtb.toFixed(2) }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Area from "@/components/Echarts/area1.vue";
import { export2Excel } from "@/utils/utils";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      exportLabel: "<<点击此处可导出报表",
      areaName: "",
      startTime: "",
      startTimeDef: "",
      endTime: "",
      endTimeDef: "",
      srcDataList: "",
      dialogTableVisible: false,
      loading: false,
      queryData: {},
      dataIndexOptions: [
        {
          value: "ZB_001",
          label: "工业用电量（亿千瓦时，%）",
          unit: "亿千瓦时",
        },
        {
          value: "ZB_002",
          label: "工业增值税（亿元，%）",
          unit: "亿元",
        },
        {
          value: "ZB_003",
          label: "铁路货运量（万吨，%）",
          unit: "万吨",
        },
        {
          value: "ZB_004",
          label: "各项贷款余额（亿元，%）",
          unit: "亿元",
        },
        {
          value: "ZB_005",
          label: "各项存款余额（亿元，%）",
          unit: "亿元",
        },
        {
          value: "ZB_006",
          label: "工业生产者出厂价格指数",
          unit: "",
        },
        {
          value: "ZB_007",
          label: "工业生产者购进价格指数",
          unit: "",
        },
        {
          value: "ZB_008",
          label: "PMI",
          unit: "",
        },
      ],
      dataIndex: "ZB_001", //数据指标
      dataTpye: "currMonth", //数据指标
      times: this.timesDef, //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      unit: "亿千瓦时",
      areaData: {
        xAxis: [],
        curr: {},
        profit: {},
        unit: "亿千瓦时",
      },
    };
  },
  components: {
    Area,
  },
  watch: {},
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    initData() {
      const self = this;
      this.queryData.startTime = this.startTime;
      this.queryData.endTime = this.endTime;
      this.queryData.code = this.dataIndex;
      this.loading = true;
      this.queryData.page = 1;
      this.queryData.pageSize = 10;
      this.$axios
        .get("/business/region/queryAntecedentList", { params: this.queryData })
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit: this.unit,
          };
          this.loading = false;
          this.showArea = false;
          this.srcDataList = res.data;
          // this.tableData = res.data
          this.getShowMonthData();
        });
    },
    getQuarter(value) {
      this.times = value;
      this.initData();
    },
    getYearRange(value) {
      this.startTime = value[0] + "-01";
      this.endTime = value[1] + "-12";
      this.initData();
    },
    getShowData(value, value1) {
      this.unit = this.dataIndexOptions.find((ele) => ele.value === value).unit;
      // this.getShowMonthData()
      this.initData();
    },
    getShowMonthData() {
      // 计算月度数据
      const self = this;
      this.tableData = [];
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: this.unit,
      };
      this.showArea = false;
      this.tableData = [];
      // 展示数据过滤
      this.srcDataList.forEach((item) => {
        item.date_range_show =
          item.date_range.split("-")[0] +
          "年" +
          item.date_range.split("-")[1] +
          "月";
        this.areaData.xAxis.push(item.date_range_show);
        if (this.dataTpye === "all") {
          this.areaData.curr.name = "累计";
          this.areaData.profit.name = "累计同比（±）";
          this.areaData.curr.data.push(item.bylj1);
          this.areaData.profit.data.push(item.ljtb);
        } else {
          this.areaData.curr.name = "本月";
          this.areaData.profit.name = "本月同比（±）";
          this.areaData.curr.data.push(item.benyue);
          this.areaData.profit.data.push(item.dytb);
        }
        this.tableData.push(item);
      });
      console.log(this.areaData, this.tableData);
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      //下面是几个if
      if (month >= 1 && month <= 3)
        return year + "-" + "01" + "," + year + "-" + "03";
      else if (month >= 4 && month <= 6) {
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    yearChange(value) {
      this.times = value + "-12";
      this.initData();
    },
    monthChange(value) {
      console.log(value);
      this.startTime = value[0];
      this.endTime = value[1];
      this.initData();
    },
    exportData() {
      let column = [
        {
          title: "时间",
          key: "date_range_show",
          rowspan: 2,
        },
        {
          title: this.dataIndexOptions.find(
            (ele) => ele.value === this.dataIndex
          ).label,
          data: [
            {
              title: "本月",
              toFixed: 2,
              key: "benyue",
            },
            {
              title: "当月环比（±）",
              toFixed: 1,
              key: "dyhb",
            },
            {
              title: "当月同比（±）",
              toFixed: 1,
              key: "dytb",
            },
            {
              title: "1-本月累计",
              toFixed: 2,
              key: "bylj1",
            },
            {
              title: "累计同比（±）",
              toFixed: 1,
              key: "ljtb",
            },
          ],
          colspan: 5,
        },
      ];
      const timeStr =
        this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
          .label +
        "_ " +
        this.times[0].slice(0, 4) +
        "年" +
        this.times[0].slice(5, 7) +
        "月到" +
        this.times[1].slice(0, 4) +
        "年" +
        this.times[1].slice(5, 7) +
        "月";
      export2Excel(column, this.tableData, timeStr);
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.times = this.defaultMonthValue;
    this.startTime = this.defaultMonthValue.slice(0, 4) + "-01";
    this.endTime = this.defaultMonthValue;
    this.times = [this.startTime, this.endTime];
    this.initData();
    this.$axios.get("/business/industry/selectIndex").then((res) => {
      this.dataIndexOptions = res.data.data;
    });
  },
};
</script>